<template>
  <div>
    <main :class="{ 'mobile-menu-open': mobileMenuShow }" ref="main">
      <div class="sections-wrapper">
        <NavigationComponent @scrollToSection="scrollToSection" @mobileMenuHandler="mobileMenuHandler" />
        <SideLoadNavComponent :sections="sections" />
        <StartingComponent ref="start" />
        <AboutComponentVue ref="about" />
        <SkillsComponent ref="skills" />
        <ResumeComponent ref="resume" />
        <ContactComponent ref="contact" />
      </div>
    </main>
    <FooterComponentVue @scrollToSection="scrollToSection" />
  </div>
</template>

<script>
import NavigationComponent from '@/components/NavigationComponent'
import FooterComponentVue from '@/components/FooterComponent.vue'
import StartingComponent from '@/components/StartingComponent'
import AboutComponentVue from './components/AboutComponent.vue'
import SkillsComponent from '@/components/SkillsComponent'
import ResumeComponent from '@/components/ResumeComponent'
import SideLoadNavComponent from '@/components/SideLoadNavComponent'
import ContactComponent from '@/components/ContactComponent'

export default {
  name: 'App',
  components: {
    NavigationComponent,
    SideLoadNavComponent,
    FooterComponentVue,
    StartingComponent,
    AboutComponentVue,
    SkillsComponent,
    ResumeComponent,
    ContactComponent,
  },
  data () {
    return {
      pluggedIn: false,
      mobileMenuShow: false,
      sections: [
        { title: 'Home', active: false },
        { title: 'About', active: false },
        { title: 'Skillset', active: false },
        { title: 'Resume', active: false },
        { title: 'Contact', active: false }
      ]
    }
  },
  methods: {
    webPlugIn () {
      this.pluggedIn = !this.pluggedIn
    },
    mobileMenuHandler () {
      this.mobileMenuShow = !this.mobileMenuShow
    },
    scrollToSection (section) {
      if (!this.$refs[section]) return
      try {
        const sectionElement = this.$refs[section].$el
        sectionElement.scrollIntoView({behavior: 'smooth', block: 'start'})
      } catch (e) {
        console.log('Section does not exist')
      }
    }
  }
}
</script>
